import React from 'react';
import { OnboardingLayout } from '../components/onboarding1/onboarding-layout';

const FunnelCreationFakePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <OnboardingLayout />
    </div>
  );
};

export default FunnelCreationFakePage;
